export enum StowageRuleConsequenceType {
    Unknown,
    HardRule,
    SoftRule,
    Warning,
}
